import { FormGroup } from '@angular/forms';
import { Component } from '@angular/core';

export abstract class BaseGridTemplate {
    constructor() { }
    isNew: boolean;
    editDataItem: any;
    abstract editForm: FormGroup;
    abstract template: any;
    abstract formDialog: any;
}

